import formatLongDate from '@UI/Helpers/formatLongDate';
import ElementDescription from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Shared/Helpers/ElementDescription';
import type DocumentView from '@UI/Store/Documents/Views/DocumentView';

/** A document of the dossier: its title, its type and the day it was generated. */
const describeDocument = (document: DocumentView, typeLabel: string): ElementDescription =>
	new ElementDescription(document.title, `${typeLabel} · Généré le ${formatLongDate(document.createdAt)}`);

export default describeDocument;
